import { InfoCircleOutlined } from "@ant-design/icons";
import { Button, Card, Checkbox, Col, Divider, Popover, Row, Space } from "antd";
import { DatePicker, Input, InputNumber, Select } from "components/form";
import dayjs from "dayjs";
import { Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { requestIdCard } from "utils/formatter/formatCommon";
import schema from "../schemas/employeeSocialSecuritySchema";
import styles from "../styles/EmployeeForm.module.css";

function EmployeeSalarySocialSecurity({
  employeeSalarySocialSecurityProps,
  registrationDocumentOptions = [],
  initialValues = {},
  hospitalOptions = [],
  reasonForSsoResignationOptions = [],
  nationalityOptions = [],
  isLoading = false,
  branchOfSsoOptions = [],
  onSubmit = () => { },
  onCancel = () => { },
}) {
  console.log("loading", isLoading);

  const { t, i18n } = useTranslation();
  const [showSocial, setShowSocial] = React.useState(false);
  const [showKortor, setShowKortor] = React.useState(false);
  const {
    hospital,
    nationality,
    socialSecurityNo,
    registrationDocument,
    reasonForSsoDocument } = useSelector((state) => state.socialSecurity);
  const currentEmployee = useSelector(
    (state) => state.employee.currentEmployee
  );

  // console.log("Hospital", hospital);
  const [socialSecurity, setSocialSecurity] = useState({})


  useEffect(() => {
    // console.log("getSocialSecurity = ", socialSecurityNo);
    setSocialSecurity({
      socialSecurityNo: requestIdCard(currentEmployee?.employeeNationality === "D" ? currentEmployee?.identificationNo : currentEmployee?.taxId || "-"),
      registrationDocument: socialSecurityNo?.registrationDocument?.id,
      hospital: i18n.language === 'en' ? socialSecurityNo?.hospital?.hospitalNameEn : socialSecurityNo?.hospital?.hospitalName,
      nationality: socialSecurityNo?.nationality?.id,
      hospitalId: socialSecurityNo?.hospital?.hospitalId,
      deliverSocialSecurity: socialSecurityNo?.deliverSocialSecurity === 'Y',
      reasonForSSOResignation: socialSecurityNo?.reasonForSSOResignation?.id,
      remark: socialSecurityNo?.remark,
      ssoReceivedDate: socialSecurityNo?.ssoReceivedDate == null ? null : dayjs(socialSecurityNo.ssoReceivedDate),
      setSocialSecurityBranchForThisEmployee: socialSecurityNo?.setSocialSecurityBranchForThisEmployee === 'Y',
      setFrom20AForThisEmployee: socialSecurityNo?.setFrom20AForThisEmployee === 'Y',
      insurancePersonContributionRate: socialSecurityNo?.insurancePersonContributionRate,
      businessCode: socialSecurityNo?.businessCode,
      branchOfSSO: socialSecurityNo?.branchOfSSO,
      reasonForSsoDocument: socialSecurityNo?.reasonForSsoDocument,
    });
    // console.log("", socialSecurityNo?.remark);
    setShowSocial(socialSecurityNo?.setSocialSecurityBranchForThisEmployee === 'Y');
    setShowKortor(socialSecurityNo?.setFrom20AForThisEmployee === 'Y')
  }, [socialSecurityNo])

  return (
    <>
      <Space style={{ width: "100%" }} size={24} direction="vertical">
        <Card>
          <Formik
            enableReinitialize
            initialValues={{ ...socialSecurity }}
            onSubmit={onSubmit}
            validationSchema={schema}
          >
            {({ values = {}, setFieldValue, submitForm }) => {
              return (
                <Form onFinish={submitForm}>
                  <span style={{ fontSize: "16px", fontWeight: "bold" }}>{t("social_security.header")}</span>
                  <Divider className={styles.customDivider} />
                  <Row gutter={[24, 16]}>
                    <Col span={24}>
                      <Checkbox name="deliverSocialSecurity" onChange={(e) => {
                        console.log("check box1 = ", setFieldValue);
                        setFieldValue('deliverSocialSecurity', e.target.checked)
                      }}
                        checked={values.deliverSocialSecurity}
                        value={values.deliverSocialSecurity} >
                        {t("social_security.label.deliver_social_security")}
                      </Checkbox>
                    </Col>
                    <Col span={12}>
                      <Input
                        name="socialSecurityNo"
                        label={t("social_security.label.social_security_no")}
                        placeholder=""
                        size="large"
                        defaultValue=""
                        disabled
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="registrationDocument"
                        label={
                          t("social_security.label.registration_document")
                        }
                        placeholder={t("common.pleaseSelect")}
                        size="large"
                        options={registrationDocument?.map((record, index) => {
                          return {
                            label: i18n.language === 'en' ? record?.nameEn : record?.name,
                            value: record?.id
                          }
                        })}
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="nationality"
                        label={
                          t("social_security.label.nationality")
                        }
                        placeholder={t("common.pleaseSelect")}
                        size="large"
                        options={nationality?.map((record, index) => {
                          return {
                            label: i18n.language === 'en' ? record?.nameEn : record?.name,
                            value: record?.id
                          }
                        })}
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="hospital"
                        label={
                          t("social_security.label.hospital")
                        }
                        placeholder={t("common.pleaseSelect")}
                        size="large"
                        onChange={(value, option) => {
                          setFieldValue("hospital", i18n.language === 'en' ? option?.nameEn : option?.name);
                          setFieldValue("hospitalId", option?.value);
                          console.log("hospitalId", option);
                        }}
                        options={hospital?.map((record, index) => {
                          // console.log("record", record);
                          return {
                            ...record,
                            label: i18n.language === 'en' ? record?.nameEn : record?.name,
                            value: record?.id
                          }
                        })}
                      />

                    </Col>
                    <Col span={12}>
                      <DatePicker
                        name="ssoReceivedDate"
                        label={t("social_security.label.sso_received_date")}
                        placeholder={t("common.placeholder.ddmmyyyy")}
                        size="large"
                      />
                    </Col>
                    <Col span={12}>
                      <Select
                        name="reasonForSSOResignation"
                        label={
                          <>
                            {t("social_security.label.reason_for_sso_resignation")}
                            <Popover content={t("social_security.popover.reason_for_sso_resignation")} trigger="hover">
                              <InfoCircleOutlined style={{ marginLeft: '5px' }} />
                            </Popover>
                          </>
                        }
                        placeholder={t("common.pleaseChoose")}
                        size="large"
                        options={reasonForSsoDocument?.map((record, index) => {
                          return {
                            label: i18n.language === 'en' ? record?.nameEn : record?.name,
                            value: record?.id
                          }
                        })}
                      />
                    </Col>
                    <Col span={24}>
                      <Input
                        name="remark"
                        label={
                          t("social_security.label.remark")
                        }
                        placeholder={
                          t("social_security.placeholders.remark")
                        }
                        size="large"
                      />
                    </Col>
                    <Col span={24}>
                      <Checkbox
                        name="setSocialSecurityBranchForThisEmployee"
                        onChange={(e) => {
                          setShowSocial(e.target.checked);
                          console.log("check box2 = ", e.target.checked);
                          setFieldValue('setSocialSecurityBranchForThisEmployee', e.target.checked);
                        }}
                        checked={values.setSocialSecurityBranchForThisEmployee}
                        value={values.setSocialSecurityBranchForThisEmployee}
                      >
                        {t("social_security.label.set_social_security")}
                      </Checkbox>
                    </Col>
                    {showSocial && (
                      <>
                        <Col span={12}>
                          <Select
                            name="branchOfSSO"
                            label={
                              t("social_security.label.branch_of_sso") + t("common.required_field_suffix")
                            }
                            placeholder={t("common.pleaseSelect")}
                            size="large"
                            options={branchOfSsoOptions}
                          />
                        </Col>
                      </>
                    )}
                    <Col span={24}>
                      <Checkbox
                        name="setFrom20AForThisEmployee"
                        onChange={(e) => {
                          setShowKortor(e.target.checked);
                          console.log("check box3 = ", setFieldValue);
                          setFieldValue('setFrom20AForThisEmployee', e.target.checked);
                        }}

                        checked={values.setFrom20AForThisEmployee}
                        value={values.setFrom20AForThisEmployee}
                      >
                        <>
                          {t("social_security.label.set_kor_tor")}
                          <Popover content={t("social_security.popover.set_kor_tor")} trigger="hover">
                            <InfoCircleOutlined style={{ marginLeft: '5px' }} />
                          </Popover>
                        </>
                      </Checkbox>
                    </Col>

                    {showKortor && (
                      <>
                        <Col span={12}>
                          <Input
                            name="businessCode"
                            label={t("social_security.label.business_code") + t("common.required_field_suffix")}
                            placeholder="-"
                            size="large"
                          />
                        </Col>
                        <Col span={12}>
                          <InputNumber
                            name="insurancePersonContributionRate"
                            label={t("social_security.label.insurance_person_contribution_rate") + t("common.required_field_suffix")}
                            placeholder="0.20"
                            size="large"
                            step={0.05}
                            max={1}
                            min={0.1}
                            formatter={value => value ? `${value.toLocaleString()}%` : ''}
                            parser={value => value ? parseFloat(value.replace('%', '')) : ''}
                          />
                        </Col>

                      </>
                    )}
                  </Row>

                  <Row justify="end" style={{ paddingTop: "24px" }}>
                    <Space size={12}>
                      <Button type="default" onClick={onCancel}
                        style={{ width: "100px", height: "44px", borderRadius: "8px", padding: "8px 16px" }}
                      >
                        {t("common.cancel").toUpperCase()}
                      </Button>

                      <Button type="primary" htmlType="submit"
                        style={{ width: "100px", height: "44px", borderRadius: "8px", backgroundColor: "var(--button-color)", padding: "8px 16px", color: "white" }}
                      >
                        {t("common.submit").toUpperCase()}
                      </Button>
                    </Space>
                  </Row>
                </Form>

              );

            }}
          </Formik>
        </Card>
      </Space>
    </>
  );
}
export default EmployeeSalarySocialSecurity;
